// Copyright (c) 2017 Deere & Company

import './pip-details.scss';
import React, {PropTypes} from 'react';
import ActionsPopover from '../../../shared/components/actions-popover';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledString from '../../../shared/components/labeled-string';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {getPipActions} from '../../shared/services/pip-actions';

const PipsDetails = (props, context) => {

    const actionList = getPipActions(context, props.pipProduct);

    return (
        <section className='open-pips-details'>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={buildDealer(props.pipProduct.responsibleAccount)}
                    label='RESPONSIBLE_ACCOUNT'
                />
                <LabeledString
                    data={buildDate(props.pipProduct.expireDate)}
                    label='EXPIRES'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={buildDealer(props.pipProduct.leadAccount)}
                    label='LEAD_ACCOUNT'
                />
                <LabeledString
                    data={buildDate(props.pipProduct.terminationDate)}
                    label='TERMINATES'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={props.pipProduct.customerSummary.displayName}
                    label='CUSTOMER'
                />
                <LabeledLink
                    data={props.pipProduct.dtac}
                    href={props.pipProduct.dtacUrl}
                    label='DTAC_SOLUTION'
                    rel='noopener noreferrer'
                    target='_blank'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={props.pipProduct.pipType.value}
                    label='PIP_TYPE'
                />
                <LabeledString
                    data={props.pipProduct.model}
                    label='MODEL'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={props.pipProduct.metric.value}
                    label='METRIC'
                />
                <LabeledString
                    data={props.pipProduct.participant.value}
                    label='PARTICIPANT'
                />
            </div>
            <div className='row'>
                <LabeledLink
                    className='lost-two-column'
                    data={props.pipProduct.description}
                    href={`#/pips/programs/${props.pipProduct.pipId}`}
                    label='PIP'
                />
                <LabeledString
                    data={props.pipProduct.pipStatus.value}
                    label='PIP_STATUS'
                />
            </div>
            <div className='row'>
                <LabeledLink
                    data={props.pipProduct.pipNumber}
                    href={`#/pips/programs/${props.pipProduct.pipId}`}
                    label='PROGRAM_NUMBER'
                />
            </div>
            {actionList.length > 0 &&
                <footer>
                    <ActionsPopover options={actionList}/>
                </footer>
            }
        </section>
    );

};

PipsDetails.displayName = 'PipsDetails';
PipsDetails.propTypes = {
    pipProduct: PropTypes.instanceOf(PipProduct).isRequired
};
PipsDetails.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default PipsDetails;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pip-details.js